<template lang="pug">
div(v-if="!cuenta")
  h1.puntostitle Los datos de la cuenta seleccionada son necesarios para conocer los puntos del cliente.
div(v-else
    v-loading="loading"
    :loading-title="$t('el.select.loading')"
    :loading-description="$t('loyalty.client')"
    loading-spinner="pulse"
    loading-background="rgba(255, 255, 255, 0.9)")

  div(v-if="detallesData")
    ods-scrollbar(wrap-class="wrap-styles"
      tag="div"
      :native="true"
      style="height: calc(100vh - 75px); padding: 0 0 32px 0;")
      ods-row(:gutter='32')
        ods-col(:span='12')
          h2.puntostitle {{ $t('loyalty.totalPointsAvaible') }}
        ods-col(:span='12')
          h2.puntostitle {{ detallesData.puntdisp }}

      ods-divider

      ods-row(:gutter='32')
        ods-col(:span='12')
          h2.puntosh2 {{ $t('loyalty.totalAccumulatedPoints') }}
          span.puntosspan {{ detallesData.puntacum }}
        ods-col(:span='12')
          h2.puntosh2 {{ $t('loyalty.totalPointsReleased') }}
          span.puntosspan {{ detallesData.puntolib }}

      ods-row(:gutter='32')
        ods-col(:span='12')
          h2.puntosh2 {{ $t('loyalty.totalPointsHeldSuspense') }}
          span.puntosspan {{ detallesData.puntretesp }}
        ods-col(:span='12')
          h2.puntosh2 {{ $t('loyalty.totalPointsWithheldBlockage') }}
          span.puntosspan {{ detallesData.puntretblo }}

      ods-row(:gutter='32')
        ods-col(:span='12')
          h2.puntosh2 {{ $t('loyalty.totalManualRetainedPoints') }}
          span.puntosspan {{ detallesData.puntretman }}
        ods-col(:span='12')
          h2.puntosh2 {{ $t('loyalty.totalPointsExceeded') }}
          span.puntosspan {{ detallesData.puntexced }}

      ods-row(:gutter='32')
        ods-col(:span='12')
          h2.puntosh2 {{ $t('loyalty.totalDefinitiveAnnulledPoints') }}
          span.puntosspan {{ detallesData.puntoanu }}
        ods-col(:span='12')
          h2.puntosh2 {{ $t('loyalty.totalPointsExpired') }}
          span.puntosspan {{ detallesData.puntcadu }}

      ods-row(:gutter='32')
        ods-col(:span='12')
          h2.puntosh2 {{ $t('loyalty.totalPointsPenalized') }}
          span.puntosspan {{ detallesData.puntpena }}
        ods-col(:span='12')
          h2.puntosh2 {{ $t('loyalty.totalPointsRedeemed') }}
          span.puntosspan {{ detallesData.cantpunt }}

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DetallePuntos',
  props: ['cuenta'],
  data: () => {
    return {
      loading: true,
      detallesData: null
    }
  },
  created () {
    this.getPoints()
  },
  destroyed () {
    this.detallesData = null
  },
  methods: {
    ...mapActions(['getAccountDetail']),
    async getPoints () {
      this.loading = true
      const response = await this.getAccountDetail({ idAccount: this.cuenta.codcuent })
      if (response.registros && response.retorno !== 210) {
        this.detallesData = response.registros
      }
      this.loading = false
    }
  }
}
</script>
<style lang="scss">
.puntostitle {
  padding-top: 15px;
  font-size: 16px;
  color: #060E14;
  font-weight: 500;
}

.puntosh2 {
  text-transform: uppercase;
}
.puntosspan {
  font-size: 12px;
  color: #060E14;
  line-height: 56px;
}
</style>
